import { Record } from 'immutable';
import PURCHASE_METHODS_V25 from 'commons-vehicle/PurchaseMethodsV25/constants/purchaseMethodsV25.js';

const FinanceOptionsModelV25Record = Record({
    isSelected: false,
    isAvailable: false,
    purchaseMethod: PURCHASE_METHODS_V25.FINANCE,
    financePlan: '',
    financePlanDescription: '',
    kmPerYearPlan: 0,
    paymentFrequency: 0,
    selectedTerm: 0,
    selectedCashDown: 0,
    selectedTotalCashDown: 0,
    selectedApr: 0,
    selectedPayment: {
        payment: 0,
        paymentTaxes: 0,
        taxesDetail: '',
        totalPayment: 0,
        validPaymentRange: [0, 0],
        validTotalPaymentRange: [0, 0],
    },
    cashDownOptions: [
        {
            cashDown: 0,
            totalCashDown: 0,
            terms: [
                {
                    term: 0,
                    apr: 0,
                    payment: 0,
                    totalPayment: 0,
                },
            ],
        },
    ],
    sellingPrice: 0,
    baseSellingPrice: 0,
    incentives: {
        effectiveIncentiveProgram: 0,
        manufacturerRebates: 0,
        governmentRebates: 0,
        dealerRebates: 0,
        total: 0,
        deliveryBonus: 0,
        electricRebateIncluded: false,
    },
    residualDetails: {
        totalResidualRetail: 0,
        totalResidualRate: 0,
        totalResidualAmount: 0,
    },
    amountFinanced: 0,
    dueAtDelivery: 0,
    buyBackAmount: 0,
    disclaimer: '',
});

class FinanceOptionsModelV25 extends FinanceOptionsModelV25Record {}

export default FinanceOptionsModelV25;
